import {Box, styled} from '@mui/material';

export const StyledNavigationDrawerLanguageSwitcherBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  padding: theme.spacing(1.5, 4, 2),
}));